<template>
<div class="page-title-container">
 <div class="container">
   <div class="row">
     <div
       v-if="isActivityCategory"
       class="col-sm-12 wow fadeIn"
     >
       <i class="fa fa-users"></i>
       <h1>組合員活動</h1>
     </div>

     <div
       v-else
       class="col-sm-12 wow fadeIn"
     >
       <i class="fa fa-info-circle"></i>
       <h1>お知らせ</h1>
     </div>
   </div>
 </div>
</div>
</template>
<script>

export default {
  name: 'PageTitleHeader',

  components: {
  },

  props: {
    categorySlug: {
      type: String,
      default: '',
    },

    category: {
      type: Object,
      default: null,
    },
  },

  data(){
    return {
    }
  },

  computed: {
    currentCateSlug() {
      if (this.category != null) return this.category.slug
      if (this.categorySlug) return this.categorySlug
    },

    isInfoCategory() {
      return this.infoCategorySlugs.includes(this.currentCateSlug)
    },

    isActivityCategory() {
      return this.activityCategorySlugs.includes(this.currentCateSlug)
    },
  },

  created() {
  },

  methods: {
  },
}
</script>
